/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_EyebrowInputs */

const en_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruction`)
};

const es_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrucción`)
};

const de_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterricht`)
};

const zh_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教学`)
};

const ar_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التعليم`)
};

const fr_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enseignement`)
};

const vi_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giảng dạy`)
};

const sw_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mafunzo`)
};

const th_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การสอน`)
};

const bs_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poduka`)
};

const ja_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスン`)
};

const ko_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레슨 안내`)
};

const pt_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrução`)
};

const it_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istruzione`)
};

const sv_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruktion`)
};

const nl_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructie`)
};

const da_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruktion`)
};

const nb_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruksjon`)
};

const fi_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opetus`)
};

const pl_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nauka gry`)
};

const ru_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обучение`)
};

const tr_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öğretim`)
};

const hi_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्देश`)
};

const id_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruksi`)
};

const ms_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bimbingan`)
};

const cs_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výuka`)
};

const el_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Διδασκαλία`)
};

const he_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הוראה`)
};

const af_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onderrig`)
};

const hu_lessons_eyebrow = /** @type {(inputs: Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oktatás`)
};

/**
* | output |
* | --- |
* | "Instruction" |
*
* @param {Lessons_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_eyebrow = /** @type {((inputs?: Lessons_EyebrowInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_EyebrowInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_eyebrow(inputs)
	if (locale === "de") return de_lessons_eyebrow(inputs)
	if (locale === "zh") return zh_lessons_eyebrow(inputs)
	if (locale === "ar") return ar_lessons_eyebrow(inputs)
	if (locale === "fr") return fr_lessons_eyebrow(inputs)
	if (locale === "vi") return vi_lessons_eyebrow(inputs)
	if (locale === "sw") return sw_lessons_eyebrow(inputs)
	if (locale === "th") return th_lessons_eyebrow(inputs)
	if (locale === "bs") return bs_lessons_eyebrow(inputs)
	if (locale === "ja") return ja_lessons_eyebrow(inputs)
	if (locale === "ko") return ko_lessons_eyebrow(inputs)
	if (locale === "pt") return pt_lessons_eyebrow(inputs)
	if (locale === "it") return it_lessons_eyebrow(inputs)
	if (locale === "sv") return sv_lessons_eyebrow(inputs)
	if (locale === "nl") return nl_lessons_eyebrow(inputs)
	if (locale === "da") return da_lessons_eyebrow(inputs)
	if (locale === "nb") return nb_lessons_eyebrow(inputs)
	if (locale === "fi") return fi_lessons_eyebrow(inputs)
	if (locale === "pl") return pl_lessons_eyebrow(inputs)
	if (locale === "ru") return ru_lessons_eyebrow(inputs)
	if (locale === "tr") return tr_lessons_eyebrow(inputs)
	if (locale === "hi") return hi_lessons_eyebrow(inputs)
	if (locale === "id") return id_lessons_eyebrow(inputs)
	if (locale === "ms") return ms_lessons_eyebrow(inputs)
	if (locale === "cs") return cs_lessons_eyebrow(inputs)
	if (locale === "el") return el_lessons_eyebrow(inputs)
	if (locale === "he") return he_lessons_eyebrow(inputs)
	if (locale === "af") return af_lessons_eyebrow(inputs)
	if (locale === "hu") return hu_lessons_eyebrow(inputs)
	return en_lessons_eyebrow(inputs)
});